import React from "react";

import StoryCard10 from "../../molecules/story-card10";
import CollectionName from "../../molecules/collection-name";
import PartialCarousel from "../../atoms/carousel-partial";

import "./video-slider.m.css";
import SecVideoSelector from "../../molecules/secvideo-selector";

const MobileVideoSlider = ({ allStories, collection, selectItem, VideosCollections }) => {
  const stories = allStories.splice(0, 7);
  return (
    <>
      <CollectionName collection={collection} isSeeMore={false} />
      <SecVideoSelector selectItem={selectItem} VideosCollections={VideosCollections} />
      <div styleName="wrapper">
        <PartialCarousel length={stories.length}>
          {stories.map((item, index) => (
            <StoryCard10 story={item} key={index} />
          ))}
        </PartialCarousel>
      </div>
    </>
  );
};

export default MobileVideoSlider;
